import _ from 'underscore';
import xtend from 'xtend';

import Store from '../lib/store/store-v2';

const KEY = 'userId';

export default function (apiBus, socketBus) {
    var state = Store();

    var apiActions = Store.ApiActions(state, KEY, {
        get: function (event) {
            state.set({
                isResolving: false,
                data: event.data
            });
        },
        edit: function update (event) {
            state.set({
                isResolving: false,
                data: event.data.users
            });
        }
    });

    var socketActions = Store.WebsocketActions(state, KEY, {
        // @TODO?
        // Not sure if we even get sockets for user
    });

    // Store.ApiEvents (bound), apiActions, EventEmitter
    Store.SubscribeToApi(apiActions, apiBus);
    var wsEvents = Store.WebsocketEvents.concat(['unlock']);
    Store.SubscribeToWebsocket(wsEvents, socketActions, socketBus);

    return {
        state: Store.Parse(state, function (data) {
            return (xtend(data, { data: data.data }));
        })
    };
};
